import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TaFormlyFieldWrapperModule } from '@ta-formly/ta-field-wrapper/ta-field-wrapper.module';
import { FormlyModule } from '@ngx-formly/core';

import { SignatureModalPageModule} from '@modals/signature-modal/signature-modal.module';
import { TaSignatureComponent } from './ta-signature.type';

@NgModule({
    declarations: [TaSignatureComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        IonicModule,
        SignatureModalPageModule,

        TaFormlyFieldWrapperModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'ta-signature',
                    component: TaSignatureComponent,
                    wrappers: ['ta-field-wrapper']
                }
            ]
        })
    ]
})
export class TaFormlySignatureModule { }
